import styled from '@emotion/styled'
import { inputStyles } from '@mindfulchefuk/design-system/Forms/form.styles'

export const Input = styled.input`
  ${inputStyles};
`
